/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260119-img1_b077af44-e7b0-41ad-897e-4006dcecfecb.png?v=1778566838',
    'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260119-img2_5b315d78-617c-4b46-a720-4b572bdb68db.png?v=1778566838',
    'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260119-img3_992a10f6-f169-4ca0-85d5-f0a4d44cba8c.png?v=1778566838',
    'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260119-img4.png',
    'https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20260119-img5.png',
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p1.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p2.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p4.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p5.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro1-2.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro2-2.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro3-2.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro4-2.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro5-2.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro1-3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro2-3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro3-3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro4-3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro5-3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p1-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p2-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p3-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p4-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p5-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-p1-2-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-p2-2-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-p3-2-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-p4-2-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-p5-2-m.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro1-3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro2-3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro3-3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro4-3.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251029-pro5-3.png",

    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p1-2.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p2-2.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p3-2.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p4-2.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p5-2.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p1-3.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p2-3.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p3-3.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p4-3.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p5-3.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p1-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p2-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p3-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p4-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p5-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p1-2-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p2-2-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p3-2-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p4-2-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p5-2-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p1-3-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p2-3-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p3-3-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p4-3-m.png",
    // "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-p5-3-m.png",

    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-banner.png",

    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-b1.png",
    "https://cdn.shopify.com/s/files/1/0670/7304/8802/files/20251028-b2.png",
  ];

  new Swiper(".sp-scroll", {
    loop: true,
    slidesPerView: "auto",
    autoplay: true,
    speed: 10000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
  });

  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  let _swiper = new Swiper(".sp-swiper-p1", {
    spaceBetween: 10,
    speed: 1,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() +
          $(".sp-header-top").height() +
          $(".sp-nav").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    var links2 = document.querySelectorAll('a[href^="#add-cart"]');
    links2.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("add-cart"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() +
          $(".sp-header-top").height() 
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let sp_price1 = 22.99;
  let sp_price2 = 49.99;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }

  const prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let num = $('#sp-num div.active').attr('data-val')
  let type = $('#sp-type div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == num  &&item.option3 == type)[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
//   price = (price + '').replace('.', ',')
//   compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .price-group .sp-row span").html(off_font);
}
$('.sp-btn-style').on('click',function(){
  let id = getCur().id
  let num = $("#calcNumber").val();
  window.location.href = '/cart/' + id + ':' + num
})

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });

  let _sptext = [
    "# Brun foncé",
    "# Brun clair",
    "# Brun rougeâtre",
    "# Brun gris",
    "# Noir",
  ];
  let _spcolor = ["#55392E", "#8F523A", "#672C1E", "#655A58", "#111111"];
  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $("#sp-color .sp-option.active").index();
    let numOptions = $("#sp-num .sp-option.active").index();
    let typeOptions = $("#sp-type .sp-option.active").index();

    _index = colorOptions;


    // if (numOptions > 0) {
    //   $(".sp-name").addClass("sp-name2");
    // } else {
    //   $(".sp-name").removeClass("sp-name2");
    // }
    // if(numOptions == 2 && typeOptions == 1){
    //     $(".product-part .sp-img-wrap .sp-img-p2").show()
    // }else{
    //     $(".product-part .sp-img-wrap .sp-img-p2").hide()
    // }

    // $(".sp-name").text(_sptext[colorOptions]);
    // $(".sp-name").css({ color: _spcolor[colorOptions] });

    $(".product-part  .sp-img-p1")[0].src = spImgList[colorOptions];
    $(".product-part  .sp-img-p3")[0].src = spImgList[numOptions];
    if (typeOptions) {
      $(".product-part  .sp-img-p4").show()
    }else{
      $(".product-part  .sp-img-p4").hide()
    }
    

    // _swiper.slideToLoop(_index);
    changePrice()
  });

  $(function () {
    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      let spNum = $(".product-part #calcNumber")[0].value;
    //   initNum += Number(spNum);

    //   // $("#calcNumber").val(1);
    //   $("#cardNum").html(initNum);
    let data = {
      id: getCur().id,
      quantity: $("#calcNumber").val()
    };
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
            $("#cardNum").removeClass("sp-gray");
        });
        },
        dataType: "json",
    });
      
      // handleAddToCart(initNum);

      // var imgs = $(".product-part .swiper-slide-active").find("img");
      var imgs = $(".product-part .sp-img-wrap");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",

          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 99,
        });

        let finish = $(".sp-cart");
        $(flyer).animate(
          {
            top: finish[0].offsetTop + $(".time-part").height(),
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");
    const paragraph2 = gradually.querySelector(".sp-title-color");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            if (paragraph) {
              const totalDelay = spans.length * 0.1 + 0.3 + 0.5;
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }
            // 段落
            if (paragraph2) {
              const totalDelay = spans.length * 0.1 + 0.3;
              paragraph2.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph2.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
});
